export const getDateStringFormat = (date: Date) => {
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const getDateAddedTwoDays = (date: string) => {
  let dateObject = new Date(date)
  dateObject.setDate(dateObject.getDate() + 2)
  return getDateStringFormat(dateObject)
}

/**
 * Convert a string date to a Date object avoiding timezone issues
 * @param date - string date
 * @returns Date object
 * @example
 * newDateFromString('2021-09-01')
 */
export const newDateFromString = (date: string) => {
  const [year, month, day] = date.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export const getMinutesDifference = (time1: string, time2: string) => {
  const [hours1, minutes1, seconds1] = time1.split(':').map(Number)
  const [hours2, minutes2, seconds2] = time2.split(':').map(Number)

  const date1 = new Date(2000, 0, 1, hours1, minutes1, seconds1)
  const date2 = new Date(2000, 0, 1, hours2, minutes2, seconds2)

  const diffInMilliseconds = Math.abs(date1.getTime() - date2.getTime())
  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60))

  return diffInMinutes
}
